import { render, staticRenderFns } from "./queCarPartner.vue?vue&type=template&id=0ca25db4&scoped=true"
import script from "./queCarPartner.vue?vue&type=script&lang=js"
export * from "./queCarPartner.vue?vue&type=script&lang=js"
import style0 from "./queCarPartner.vue?vue&type=style&index=0&id=0ca25db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca25db4",
  null
  
)

export default component.exports